import register from '@kpsys/angularjs-register';
import LoanRequestService from './loan-request.service';
import LoanService from './loan.service';
import loansRoutes from './loans-page/loans.routes';
import LoanDataService from './loan.data-service';
import LoanRequestDataService from './loan-request.data-service';
import {CancellationDataService} from './cancellation.data-service';
import {LoansPageService} from 'src/features/loan/loans-page/loans-page.service';

export default register('portaro.features.loan')
    .config(loansRoutes)
    .service(LoanDataService.serviceName, LoanDataService)
    .service(LoanRequestDataService.serviceName, LoanRequestDataService)
    .service(CancellationDataService.serviceName, CancellationDataService)
    .service(LoanService.serviceName, LoanService)
    .service(LoanRequestService.serviceName, LoanRequestService)
    .service(LoansPageService.serviceName, LoansPageService)
    .name();